import {
  resolveFullCheckoutUpdates,
  resolveSignalManagerCheckout,
  resolveMcpStandaloneCheckout,
  resolveEaHostingCheckout,
  toCheckoutSelection
} from 'lib/billing';

// Single source of truth for resolving the checkout plan from store state, so the card
// (PaymentStep) and crypto (CryptoElement) tabs resolve the cart identically. A room
// (Signal Manager) and a standalone AI Connect are create-only — no trading-sub diff, no trial.
export function buildCheckoutPlan(state: any): {
  plan: any;
  trialContext: { usedProductIds: string[]; skipTrial: boolean };
} {
  if (state.signalManagerSelected) {
    return {
      plan: resolveSignalManagerCheckout(state.catalog),
      trialContext: { usedProductIds: [], skipTrial: true }
    };
  }

  // AI Connect bought on its own subscription so the entered coupon reaches
  // CreateSubscription and discounts MCP alone (a Stripe discount is
  // subscription-scoped; as a line on the base plan it would discount everything).
  if (state.mcpStandalone) {
    return {
      plan: resolveMcpStandaloneCheckout(state.catalog, state.billingCycle),
      trialContext: { usedProductIds: [], skipTrial: true }
    };
  }

  // EA Hosting bought/resized on its own subscription (slot quantity =
  // state.eaHostingSlots). An existing EA sub turns this into a quantity
  // modify; a new buyer gets a create-only plan. Coupon-scoped like MCP.
  // A new buyer's create rides the price's trial_period_days unless the EA
  // trial is already used — there is no "buy now" choice in this flow (it
  // opens on Payment), and slot modifies never carry a trial.
  if (state.eaHostingStandalone) {
    return {
      plan: resolveEaHostingCheckout(state.catalog, state.billingCycle, state.eaHostingSlots, state.subscriptions || []),
      trialContext: { usedProductIds: (state.trialUsedProductIds as string[]) || [], skipTrial: false }
    };
  }

  // Normalize to the full AddonEntitlements shape; missing → not owned → false.
  const currentAddons = {
    analyzer: Boolean(state.currentAddons?.analyzer),
    dedicated: Boolean(state.currentAddons?.dedicated),
    mcp: Boolean(state.currentAddons?.mcp)
  };
  // toCheckoutSelection also carries the dedicated sub ids/kinds the futures-DE
  // resolution needs — a hand-rolled literal would silently drop them.
  const selection = toCheckoutSelection(state);
  const trialUsedProductIds = (state.trialUsedProductIds as string[]) || [];
  return {
    plan: resolveFullCheckoutUpdates(selection, state.catalog, state.subscriptions || [], currentAddons, {
      trialUsedProductIds,
      skipTrial: Boolean(state.skipTrial)
    }),
    trialContext: { usedProductIds: trialUsedProductIds, skipTrial: Boolean(state.skipTrial) }
  };
}
